@if (Status === TRIAL_STATUS.ACTIVE.toLowerCase()) {
  <div class="status-icon">
    <i class="ra-icon-ide-md-color-check"></i>
    <span>Active</span>
  </div>
}
@if (Status === TRIAL_STATUS.ENDED.toLowerCase()) {
  <div class="status-icon">
    <i class="ra-icon-ide-md-color-unprovisioned"></i>
    <span>Ended</span>
  </div>
}
@if (Status === TRIAL_STATUS.PROVISIONING.toLowerCase()) {
  <div class="status-icon">
    <i
      class="ra-icon-ide-md-color-alarm-medium-priority"
      [raUiTooltip]="'Set up for one or more trial items needs to be completed from within that application. Go to the Hub Home to open.'"
      [tooltipConfig]="tooltipConfig"
    ></i>
    <span>Needs action</span>
  </div>
}
@if (Status === USER_ASSIGNED_TRIAL_STATUS.EXPIRED.toLowerCase()) {
  <div class="status-icon">
    <i class="ra-icon-ide-md-color-unprovisioned"></i>
    <span>Expired</span>
  </div>
}
